module.exports = __webpack_public_path__ + "static/media/icon-house.e76bb15f.svg";